 
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import * as analytics from './analytics/analytics';
import config from './config';
import * as reducerRegistry from './ducks/reducerRegistry';
import createReducer from './reducers';

/**
 * Create a new store with the given initial state. Adds Redux
 * middleware and enhancers.
 */
export default function configureStore(initialState = {}, sdk = null, analyticsHandlers = []) {
  const middlewares = [thunk.withExtraArgument(sdk), analytics.createMiddleware(analyticsHandlers)];

  // Enable Redux Devtools in client side dev mode.
  const composeEnhancers =
    config.dev && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  const rootReducer = createReducer();
  const store = createStore(rootReducer, initialState, enhancer);

  // A page duck can register its reducer without any action being dispatched afterwards: routes
  // without loadData on the client, and — during SSR — any duck whose chunk is first evaluated in
  // the middle of the render (loadable resolves chunks synchronously on the server, so the duck's
  // module-level register() runs right before the page component's selectors read the slice).
  // replaceReducer makes redux re-run the root reducer synchronously, which initialises the
  // freshly injected slice before the next getState() call.
  //
  // Server stores are created per request; the subscription must be released after the render
  // (renderApp calls store.unsubscribeFromReducerRegistry) or every request's store would be
  // retained for the lifetime of the process.
  store.unsubscribeFromReducerRegistry = reducerRegistry.subscribe(() =>
    store.replaceReducer(rootReducer),
  );

  return store;
}
